/**
 * `id_opcao_atendimento` da API para payloads específicos de ocorrência.
 * Inclua novos ids quando surgirem opções com o mesmo formato.
 */
export const OCCURRENCE_NAP_LOTADA_SERVICE_OPTION_IDS = new Set(["35"]);

export function isOccurrenceNapLotadaPayload(serviceOptionId) {
  return OCCURRENCE_NAP_LOTADA_SERVICE_OPTION_IDS.has(
    String(serviceOptionId ?? ""),
  );
}
